import { useState } from "react";
import MainContainer from "../../components/app/maincontainer";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { MainBtn } from "../../components/app/buttons";
import { NewInput, TextBox } from "../../components/inputs/main";
import { apiCall } from "../../data/useFetcher";
import useErrorStore from "../../data/stores/errorStore";
import { toast } from "react-toastify";
import DoneModal, { DeleteModal } from "../../components/modals/donemodal";
import Check from "../../assets/icons/Group.svg";
import Delete from "../../assets/icons/delete-bin-5-line.svg";
import { useRequestStore } from "../../data/stores/loggerStore";
import DOMPurify from "dompurify";

export const createMarkup = (html: string) => {
  return {
    __html: DOMPurify.sanitize(html || ""),
  };
};

const AddTools = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  // Get tool data - prefer nested tool object, fallback to state
  const toolData = state?.tool || state;
  const toolSelection = toolData?.toolSelection || [];

  // Get resources and utilities from tool data
  const resources = toolData?.resources || [];
  const utilities = toolData?.utilities || [];
  const features = toolData?.features || [];

  return (
    <div>
      <MainContainer>
        <div className="mt-8 flex justify-between items-center">
          <div className="flex gap-2">
            <FaChevronLeft
              color="#334155"
              onClick={() => navigate(-1)}
              className="cursor-pointer mt-1"
            />
            <div>
              <h1 className="text-xl font-semibold text-da-blue-600 inter">
                {"View Request"}
              </h1>
              <div className="flex gap-2 items-center">
                <span className="text-base font-normal text-[#334155]">
                  Dashboard
                </span>
                <FaChevronRight color="#334155" size={10} />
                <span className="text-base font-normal text-[#334155]">
                  Request Details
                </span>
              </div>
            </div>
          </div>
          <ActionButton item={state} />
        </div>
        <div className="mt-12 bg-white w-full p-8">
          <div
            style={{
              borderBottom: "1px solid #E2E8F0",
            }}
            className="h-full w-1/2 pb-3"
          >
            <h4 className="text-xl font-semibold inter text-da-blue-600">
              General Information
            </h4>
          </div>
          <div className="mt-6">
            <div className="w-1/2 space-y-5">
              <div>
                <NewInput
                  type="text"
                  name={"toolName"}
                  value={toolData?.toolName || state?.toolName}
                  label={"Tool Name"}
                  placeholder={"Type your product name"}
                  readOnly
                />
              </div>
              <div>
                <NewInput
                  readOnly
                  type="text"
                  name={"organizationName"}
                  value={state?.organizationName}
                  label={"Organization Name"}
                  placeholder={"Type your organization name"}
                />
              </div>
              <div>
                <TextBox
                  readOnly
                  name={"description"}
                  value={toolData?.description || state?.description}
                  label={"Description"}
                  placeholder={"Tell us about your tool and company here"}
                  type="editor"
                  setState={() => {}}
                />
              </div>
              <div>
                <NewInput
                  type="email"
                  name={"contactEmailAddress"}
                  value={
                    toolData?.contactEmailAddress || state?.contactEmailAddress
                  }
                  label={"Contact Email Address"}
                  placeholder={"email address"}
                  readOnly
                />
              </div>
              <div className="grid grid-cols-2 gap-5 mb-4">
                <div>
                  <NewInput
                    readOnly
                    type="url"
                    name={"website"}
                    value={toolData?.website || state?.website}
                    label={"Website"}
                    placeholder={"Type your website"}
                  />
                </div>
                <div>
                  <NewInput
                    readOnly
                    type="url"
                    name={"webinar"}
                    value={toolData?.webinar || ""}
                    label={"Webinar"}
                    placeholder={"Type your webinar"}
                  />
                </div>
              </div>
              <div className="mb-4">
                <NewInput
                  readOnly
                  type="url"
                  name={"logo"}
                  value={toolData?.logo || ""}
                  label={"Logo"}
                  placeholder={"Type your logo url"}
                />
                {toolData?.logo && (
                  <div className="mt-2">
                    <img
                      src={toolData.logo}
                      alt="Tool logo"
                      className="w-24 h-24 object-contain rounded"
                    />
                  </div>
                )}
              </div>
              {resources && resources.length > 0 && (
                <>
                  <label className="text-[#334155] font-medium text-sm inter mt-4">
                    Resources
                  </label>
                  {resources.map((item: any, index: number) => (
                    <div key={index} className="grid grid-cols-2 w-4/5 gap-5">
                      <div>
                        <NewInput
                          readOnly
                          value={item?.material || ""}
                          label={index === 0 ? "Learning Materials" : ""}
                          placeholder={"EDAMS Technology"}
                        />
                      </div>
                      <div>
                        <NewInput
                          readOnly
                          label={index === 0 ? "Link" : ""}
                          placeholder="https://www.google.com"
                          type="url"
                          value={item?.link || ""}
                        />
                      </div>
                    </div>
                  ))}
                </>
              )}
              {utilities && utilities.length > 0 && (
                <>
                  <label className="text-[#334155] font-medium text-sm inter mt-4">
                    Utilities
                  </label>
                  {utilities.map((item: any, index: number) => (
                    <div key={index} className="grid w-4/5 gap-5">
                      <div>
                        <NewInput
                          readOnly
                          value={item?.address || ""}
                          label={index === 0 ? "Address" : ""}
                          placeholder={"EDAMS Technology"}
                        />
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
          <div className="mt-8">
            <div
              style={{
                borderBottom: "1px solid #E2E8F0",
              }}
              className="h-full w-1/2 pb-3"
            >
              <h4 className="text-xl font-semibold inter text-da-blue-600">
                Tool Category
              </h4>
            </div>
            <div className="mt-6 grid w-1/2 grid-cols-2 gap-6">
              {toolSelection.map((item: any, i: number) => (
                <div key={i}>
                  <small className="text-[#334155] font-medium text-sm inter capitalize">
                    {item?.category ? item.category.toLowerCase() : ""}
                  </small>
                  <div
                    style={{
                      border: "1px solid #E2E8F0",
                    }}
                    className="h-10 mt-2 w-full rounded-lg bg-white px-2 flex items-center"
                  >
                    <span className="text-sm font-medium text-[#334155] line-clamp-1">
                      {Array.isArray(item?.data)
                        ? item.data.join(", ")
                        : item?.data?.[0] || "N/A"}
                    </span>
                  </div>
                </div>
              ))}
            </div>
            {features && features.length > 0 && (
              <div className="mt-8">
                <div
                  style={{
                    borderBottom: "1px solid #E2E8F0",
                  }}
                  className="h-full w-1/2 pb-3"
                >
                  <h4 className="text-xl font-semibold inter text-da-blue-600">
                    Features
                  </h4>
                </div>
                <div className="mt-6">
                  <ul className="list-disc list-inside space-y-2">
                    {features.map((feature: string, index: number) => (
                      <li
                        key={index}
                        className="text-sm font-normal text-[#64748B]"
                      >
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
            {toolData?.additionalInformation && (
              <div className="mt-8">
                <div
                  style={{
                    borderBottom: "1px solid #E2E8F0",
                  }}
                  className="h-full w-1/2 pb-3"
                >
                  <h4 className="text-xl font-semibold inter text-da-blue-600">
                    Additional Information
                  </h4>
                </div>
                <div className="mt-6">
                  <div
                    className="text-sm font-normal text-da-blue-600"
                    dangerouslySetInnerHTML={createMarkup(
                      toolData.additionalInformation
                    )}
                  />
                </div>
              </div>
            )}
          </div>
          <ActionButton item={state} />
        </div>
      </MainContainer>
    </div>
  );
};

export default AddTools;

export const ActionButton = ({
  item,
  popupRef,
  openPopup,
  setOpenPopup,
  setModal: setModal2,
  usecase,
  tab,
}: any) => {
  let navigate = useNavigate(),
    { getLogger, getDynamicLogger } = useRequestStore();

  let options: any[] = usecase
      ? [
          {
            icon: Check,
            name: "view request",
            color: "#505666",
            action: (state: any) =>
              navigate(
                `${state?.tool?.toolName || state?.toolName || openPopup}`,
                { state }
              ),
          },
        ]
      : [],
    reuse = [
      // {
      // 	name: "Resend",
      // 	className: "",
      // 	bg: "#3787FF",
      // 	color2: "white",
      // 	action2: "resend",
      // 	icon: Check,
      // 	color: "#505666",
      // 	action: (sta: any) => {
      // 		setModal2([sta]);
      // 		setOpenPopup(null);
      // 	},
      // },
      {
        name: "Cancel",
        className: "border border-[#FECACA]",
        bg: "transparent",
        action2: "canceled",
        color2: "#EF4444",
        icon: Delete,
        color: "#C5292A",
        action: (sta: any) => {
          setModal2([sta]);
          setOpenPopup(null);
        },
      },
    ],
    [statusText, setStatusText] = useState(""),
    [modal, setModal] = useState("");

  if (item?.statusText === "canceled" && !item?.tool)
    options = [
      ...options,
      {
        name: "Resend",
        className: "",
        bg: "#3787FF",
        color2: "white",
        action2: "resend",
        icon: Check,
        color: "#505666",
        action: (sta: any) => {
          setModal2([sta]);
          setOpenPopup(null);
        },
      },
    ];

  // if (item?.tool && usecase)
  // 	options = [
  // 		...options,
  // 		{
  // 			name: "Update Tool",
  // 			className: "",
  // 			bg: "#3787FF",
  // 			color2: "white",
  // 			action2: "update",
  // 			icon: Check,
  // 			color: "#505666",
  // 			action: (sta: any) => {
  // 				setModal2([sta]);
  // 				setOpenPopup(null);
  // 			},
  // 		},
  // 	];

  if (
    (item?.statusText === "completed" && usecase) ||
    (item?.tool &&
      usecase &&
      ["pending", "accepted"]?.includes(item?.statusText))
  )
    options = [
      ...options,
      {
        icon: Check,
        name: "view tool",
        color: "#505666",
        action: (state: any) =>
          navigate(`/tools/${state?.tool?.toolName || openPopup}`, {
            state: state?.tool,
          }),
      },
    ];

  if (item?.statusText === "accepted") options = [...options, ...reuse];

  if (item?.statusText === "pending" && !item?.createdBy)
    options = [
      ...options,
      {
        name: "Accept",
        className: "",
        bg: "#3787FF",
        color2: "white",
        action2: "accepted",
        color: "#505666",
        action: (sta: any) => {
          setModal2([sta]);
          setOpenPopup(null);
        },
        icon: Check,
      },
      {
        name: "Reject",
        className: "border border-[#FECACA]",
        bg: "transparent",
        action2: "rejected",
        color2: "#EF4444",
        color: "#C5292A",
        action: (sta: any) => {
          setModal2([sta]);
          setOpenPopup(null);
        },
        icon: Delete,
      },
    ];
  else if (!["completed", "canceled"]?.includes(item?.statusText))
    options = [...options, ...reuse];

  if (["accepted"]?.includes(item?.statusText) && item?.tool) {
    options = options?.filter((it) => it?.name !== "Cancel");
  }

  options = options?.filter(
    (item, index, self) =>
      index ===
      self.findIndex((t) => JSON.stringify(t) === JSON.stringify(item))
  );

  let [loading, setLoading] = useState(null),
    { returnErrors } = useErrorStore();
  const onSubmit = async () => {
    setLoading(true);

    let { response, errArr, errMsg } = await apiCall({
      type: "put",
      url: `/api/v1/tools/new-request`,
      data: {
        request: item?._id,
        statusText,
      },
    });
    // console.log({ response, errArr, errMsg });
    if (errArr) {
      setLoading(false);
      return returnErrors(errArr);
    }
    if (errMsg) {
      setLoading(false);
      return toast.error(errMsg);
    }
    setLoading(false);
    if (response) {
      setStatusText("");
      if (!usecase) setModal("done");
      else {
        setOpenPopup(null);
        apiCall({
          type: "get",
          url: `/api/v1/tools/new-request${
            tab !== "all" ? `?statusText=${tab}` : ""
          }`,
          getter: (d: any) =>
            tab !== "all" ? getDynamicLogger(d, tab) : getLogger(d),
        });
        apiCall({
          type: "get",
          url: `/api/v1/tools/new-request/stat`,
          getter: (d: any) => getDynamicLogger(d, "stat"),
        });
      }
      return;
    }
    setLoading(false);
  };

  return (
    <>
      {!usecase && (
        <div className="flex gap-5 mt-6">
          {options?.map((act: any, ind: number) => (
            <MainBtn
              key={ind}
              onClick={(e) => {
                e?.preventDefault();
                setStatusText(act?.action2);
              }}
              className={act?.className}
              text={act?.name}
              bg={act?.bg}
              color={act?.color2}
            />
          ))}
        </div>
      )}
      {usecase && (
        <>
          {options?.map((op: any, idx: number) => (
            <button
              key={idx}
              onClick={() =>
                op?.action2
                  ? setStatusText(op?.action2)
                  : op?.action
                  ? op?.action(item)
                  : {}
              }
              ref={popupRef}
              className={`h-9 w-32 ${
                idx === 0 && "bg-[#F4F4F4]"
              } bg-transparent flex gap-3 rounded-lg items-center`}
            >
              <img src={op?.icon} alt="" className="" />
              <span
                style={{
                  color: op?.color,
                }}
                className="font-normal capitalize text-sm"
              >
                {op?.name}
              </span>
            </button>
          ))}
        </>
      )}
      {statusText && (
        <DeleteModal
          close={() => onSubmit()}
          handleClose={() => setStatusText("")}
          loading={loading}
          color={options?.find((ic) => ic?.action2 === statusText)?.color2}
          bg={options?.find((ic) => ic?.action2 === statusText)?.bg}
          className={
            options?.find((ic) => ic?.action2 === statusText)?.className
          }
          text={options?.find((ic) => ic?.action2 === statusText)?.name}
          mainContent={`Proceed to ${
            options?.find((ic) => ic?.action2 === statusText)?.name
          } Request`}
        />
      )}
      {modal === "done" && (
        <DoneModal
          page={"Tool"}
          path={"/new-request"}
          handleClose={() => setModal("")}
        />
      )}
    </>
  );
};
